module.exports = __webpack_public_path__ + "img/profile-pic-concert.63620650.jpg";